import React from "react"
import {ActiveUnderline} from "../../components"
import {SnailItemActiveIndicatorProps} from "../props"

export const StandardSnailItemActiveIndicator = ({isActive}: SnailItemActiveIndicatorProps) => {
    return <ActiveUnderline isActive={isActive} />
}

export default StandardSnailItemActiveIndicator
